import React from "react";
import {
  createStore, combineReducers, applyMiddleware, compose,
} from "redux";
import { Provider } from "react-redux";
import thunkMiddleware from "redux-thunk";
import { reducer as reduxFormReducer } from "redux-form";

import SignupForm from "./form/Form";
import formReducer from "./form/reducer";

const reducers = combineReducers({
  form: reduxFormReducer,
  fundraiserSignup: formReducer,
});

// create store, using the reducer provided by 'redux-form'
const store = createStore(
  reducers,
  compose(
    applyMiddleware(thunkMiddleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f,
  ),
);

const FundraiserSignup = () => (
  <Provider store={store}>
    <div className="signup-form">
      <SignupForm />
    </div>
  </Provider>
);

export default FundraiserSignup;
